module.exports = __webpack_public_path__ + "static/img/lock.3720ff25.svg";